<app-text-field *ngIf="parameter" [color]="parameter.color" [hint]="parameter.timestamp"
  [label]="'parameter.' + parameter.name | translate" [(value)]="parameter.value"></app-text-field>
